import { cva } from 'class-variance-authority';
import { Flex, Icon, Text } from '@nula/core-ui';
import type { RecordingStatus } from '@/lib/recordings/types/types';
import styles from './recording-stages.module.css';

const STEPS = ['Saved', 'Uploading', 'Transcribing'] as const;

function currentStep(status: RecordingStatus | null): number {
  return status === 'pending' || status === 'transcribing' ? 2 : 1;
}

const dot = cva(styles.dot, {
  variants: { state: { current: styles.dotCurrent, upcoming: styles.dotUpcoming } },
});

export function RecordingStages({ status }: { status: RecordingStatus | null }) {
  const current = currentStep(status);
  return (
    <Flex
      role="status"
      aria-label={`${STEPS[current]}, step ${current + 1} of ${STEPS.length}`}
      align="center"
      gap={3}
      className={styles.pill}
    >
      {STEPS.map((label, i) => (
        <Flex key={label} component="span" align="center" gap={1} aria-hidden="true">
          {i < current ? (
            <Icon name="check" size={14} className={styles.check} />
          ) : (
            <Flex component="span" className={dot({ state: i === current ? 'current' : 'upcoming' })} />
          )}
          <Text
            size="sm"
            type={i < current ? 'secondary' : undefined}
            className={i === current ? styles.currentLabel : i > current ? styles.upcomingLabel : undefined}
          >
            {label}
          </Text>
        </Flex>
      ))}
    </Flex>
  );
}
